import {
  mobileBackgroundRssNames,
  mobileGameRssNames,
  mobileBonusBoardRssNames,
  mobileControlRssNames,
  screenChangeMobileAnimationNames,
} from './mobileResourceNames';
import { crystalsResources, movingLightEffectResourceNames, stoneLightResources } from './gameConstants';

export const mobileBackgroundSharedResources = [
  { name: mobileBackgroundRssNames.homeIcon, path: 'icons/home_button.png' },
  { name: mobileBackgroundRssNames.shadow, path: 'mobileAssets/shadow.svg' },
];

export const mobileBackgroundResources = [
  ...crystalsResources,
  ...mobileBackgroundSharedResources,
  { name: movingLightEffectResourceNames.star, path: 'animations/moving_light_effect/star.png' },
  { name: mobileBackgroundRssNames.backgroundFirstLayer, path: 'mobileAssets/background_1_mob.png' },
  { name: mobileBackgroundRssNames.plusIcon, path: 'icons/plus_icon.svg' },
  { name: mobileBackgroundRssNames.backgroundSecondLayer, path: 'mobileAssets/background_2_mob.png' },
  { name: mobileBackgroundRssNames.lastResultsOpacity, path: 'icons/last_results_opacity.svg' },
  {
    name: mobileBackgroundRssNames.plants,
    path: 'mobileAnimations/main_plants/plants.json',
    config: {
      metadata: {
        spineAtlasFile: 'mobileAnimations/main_plants/plants.atlas',
      },
    },
  },
  {
    name: mobileBackgroundRssNames.stoneSpine,
    path: 'mobileAnimations/main_stones/stones.json',
    config: {
      metadata: {
        spineAtlasFile: 'mobileAnimations/main_stones/stones.atlas',
      },
    },
  },
];

export const mobileBackgroundPreBonusResources = [
  ...mobileBackgroundSharedResources,
  { name: mobileBackgroundRssNames.preBonusBackgroundFirstLayer, path: 'mobileAssets/background_1_mob_scene_2.png' },
  { name: mobileBackgroundRssNames.preBonusBackgroundSecondLayer, path: 'mobileAssets/background_2_mob_scene_2.png' },
  { name: mobileBackgroundRssNames.crystalLogo, path: 'mobileAssets/crystal_crash_logo.png' },
  {
    name: mobileBackgroundRssNames.logoSpine,
    path: 'mobileAnimations/logo/logo.json',
    config: {
      metadata: {
        spineAtlasFile: 'mobileAnimations/logo/logo.atlas',
      },
    },
  },
  {
    name: mobileBackgroundRssNames.preBonusStoneSpine,
    path: 'mobileAnimations/pre_bonus_stones/stones.json',
    config: {
      metadata: {
        spineAtlasFile: 'mobileAnimations/pre_bonus_stones/stones.atlas',
      },
    },
  },
  {
    name: mobileBackgroundRssNames.preBonusPlants,
    path: 'mobileAnimations/pre_bonus_plants/plants.json',
    config: {
      metadata: {
        spineAtlasFile: 'mobileAnimations/pre_bonus_plants/plants.atlas',
      },
    },
  },
];

export const mobileBackgroundBonusResources = [
  ...crystalsResources,
  ...mobileBackgroundSharedResources,
  ...stoneLightResources,
  { name: mobileBackgroundRssNames.bonusBackgroundFirstLayer, path: 'mobileAssets/background_1_mob_scene_3.png' },
  { name: mobileBackgroundRssNames.bonusBackgroundSecondLayer, path: 'mobileAssets/background_2_mob_scene_3.png' },
  { name: mobileBackgroundRssNames.lastResultsOpacity, path: 'icons/last_results_opacity.svg' },
  {
    name: mobileBackgroundRssNames.bonusPlants,
    path: 'mobileAnimations/bonus_plants/plants.json',
    config: {
      metadata: {
        spineAtlasFile: 'mobileAnimations/bonus_plants/plants.atlas',
      },
    },
  },
  {
    name: mobileBackgroundRssNames.bonusStoneSpine,
    path: 'mobileAnimations/bonus_stones/stones.json',
    config: {
      metadata: {
        spineAtlasFile: 'mobileAnimations/bonus_stones/stones.atlas',
      },
    },
  },
  {
    name: mobileBackgroundRssNames.bonusTreeSpine,
    path: 'mobileAnimations/bonus_stone_tree_light/stone_tree_light.json',
    config: {
      metadata: {
        spineAtlasFile: 'mobileAnimations/bonus_stone_tree_light/stone_tree_light.atlas',
      },
    },
  },
];

export const mobileBgAnimationNames = {
  glow: 'stones',
  blue: 'blue',
  green: 'green',
  magenta: 'purple',
  yellow: 'yellow',
  gold: 'yellow',
};


export const mobileGamePadResources = [
  { name: mobileGameRssNames.spinIcon, path: 'icons/spin_full_icon.svg' },
  { name: mobileGameRssNames.betAmountIcon, path: 'icons/bet_amount_icon.svg' },
  { name: mobileGameRssNames.buttonBorderNonActive, path: 'icons/button_border_non_active.svg' },
  { name: mobileGameRssNames.buttonBorderActive, path: 'icons/button_border_active.svg' },
  { name: mobileGameRssNames.autoplayIcon, path: 'icons/autoplay_icon.svg' },
  { name: mobileGameRssNames.leftArrowIcon, path: 'icons/left_arrow_icon.svg' },
  { name: mobileGameRssNames.rightArrowIcon, path: 'icons/right_arrow_icon.svg' },
  { name: mobileGameRssNames.betAmountMinus, path: 'icons/bet_amount_minus.svg' },
  { name: mobileGameRssNames.betAmountPlus, path: 'icons/bet_amount_plus.svg' },
  { name: mobileGameRssNames.mobileController, path: 'icons/mobile_controller.svg' },
  { name: mobileGameRssNames.infinityIcon, path: 'icons/infinity_icon.svg' },
  { name: mobileGameRssNames.infinityIconDark, path: 'icons/infinity_icon_bark.svg' },
  { name: mobileGameRssNames.autoSpinIcon, path: 'icons/autospin_button.svg' },
];

export const mobileBonusBoardResources = [
  { name: mobileBonusBoardRssNames.bonus_button_mobile, path: 'mobileAssets/bonus_button_mobile.png' },
  {
    name: mobileBonusBoardRssNames.bonus_buttonAnimation,
    path: 'mobileAnimations/buy_bonus/bonus_button_mobile.json',
    config: {
      metadata: {
        spineAtlasFile: 'mobileAnimations/buy_bonus/bonus_button_mobile.atlas',
      },
    },
  },
];

export const mobileControlResources = [
  { name: mobileControlRssNames.historyIcon, path: 'icons/history_icon_mobile.svg' },
  { name: mobileControlRssNames.historyIconActive, path: 'icons/history_icon_mobile_active.svg' },
  { name: mobileControlRssNames.infoIcon, path: 'icons/info_icon_mobile.svg' },
  { name: mobileControlRssNames.infoIconActive, path: 'icons/info_icon_mobile_active.svg' },
  { name: mobileControlRssNames.soundOnIcon, path: 'icons/sound_on_icon_mobile.svg' },
  { name: mobileControlRssNames.soundOffIcon, path: 'icons/sound_off_icon_mobile.svg' },
];

export const mainToPreBonusAnimationResource = [
  {
    name: screenChangeMobileAnimationNames.mainToPreBonus,
    path: 'mobileAnimations/scene_1_transition/wheel.json',
    config: {
      metadata: {
        spineAtlasFile: 'mobileAnimations/scene_1_transition/wheel.atlas',
      },
    },
  },
];

export const preBonusToBonusAnimationResource = [
  {
    name: screenChangeMobileAnimationNames.preBonusToBonus,
    path: 'mobileAnimations/scene_2_transition/wheel.json',
    config: {
      metadata: {
        spineAtlasFile: 'mobileAnimations/scene_2_transition/wheel.atlas',
      },
    },
  },
];

export const screenChangeMobileAnimationResources = [];
